import React from 'react';
import './PostPreview.css';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { ButtonPlus } from '../ButtonSquare';

const PostPreview = (props) => {
  const {
    pictureSrc, title, subtitle, link, theme, alt,
  } = props;
  return (
    <div className="post">
      <div className="post-image-container">
        <Img sizes={pictureSrc} alt={alt} className="post-image" />
        <ButtonPlus theme={theme} link={link} />
      </div>
      <div className="post_titles">
        <h3 style={{
          color: theme === 'dark' ? '#2f1275' : 'white',
        }}
        >
          {subtitle}
        </h3>
        <h4 style={{
          color: theme === 'dark' ? '#2f1275' : 'white',
        }}
        >
          {title}
        </h4>
      </div>

    </div>
  );
};

PostPreview.defaultProps = {
  theme: 'light',
};

PostPreview.propTypes = {
  pictureSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  theme: PropTypes.string,
};

export default PostPreview;



// WEBPACK FOOTER //
// ./src/components/PostPreview/PostPreview.jsx